import { RefObject, useLayoutEffect } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import { CodeScannerFormat } from "../code-scanner/code-scanner";
import { BarcodeFormat } from "@zxing/library";

export const useZxingCodeDetector = (videoElement: RefObject<HTMLVideoElement>,
                                     formats: CodeScannerFormat[], onValueScanned: (value: string) => void) => {
    return useLayoutEffect(() => {
        if (!videoElement.current) {
            return;
        }

        const timer = setInterval((async () => {
            if (!videoElement.current || !videoElement.current.readyState) {
                return;
            }

            try {
                const cameraCodeReader = new BrowserMultiFormatReader();
                const result = await cameraCodeReader.decodeOnceFromVideoElement(videoElement.current!);
                if (result) {
                    if (result.getBarcodeFormat() === BarcodeFormat.QR_CODE && !formats.includes(CodeScannerFormat.QR_CODE)
                        || result.getBarcodeFormat() !== BarcodeFormat.QR_CODE && !formats.includes(CodeScannerFormat.BARCODE)) {
                        return;
                    }

                    onValueScanned(result.getText());
                }
            } catch (error) {
                return;
            }
        }), 350);

        return () => clearInterval(timer);
    }, [videoElement, formats, onValueScanned]);
};
